import AverageNumberOfClientsPerClassModule from "./averageNumberOfClientsPerClassModule";
import AverageNumberOfVisitsPerClientReducer from "./redux/averageNumberOfClientsPerClassReducer";
import averageNumberOfClientsPerClassSagas from "./redux/averageNumberOfClientsPerClassSagas";

export default {
  Component: AverageNumberOfClientsPerClassModule,
  moduleName: "averageNumberOfClientsPerClass",
  saga: averageNumberOfClientsPerClassSagas(),
  reducer: AverageNumberOfVisitsPerClientReducer
};
